import React from 'react';
import { StatusBadge, GlassCard, PageHeader as DesignPageHeader } from '@/components/design';

// Shared primitives used across every page. The public API is unchanged so
// existing pages keep working; the visuals come from the design system.

export function SectionBadge({ status, label }) {
  return <StatusBadge status={status} label={label} />;
}

export function PageHeader(props) {
  return <DesignPageHeader {...props} />;
}

const TONE_CLASS = { green: 'green', amber: 'amber', red: 'red', navy: 'navy' };

export function KPI({ label, value, target, status = 'green', icon }) {
  return (
    <div className={`kpi-card ${TONE_CLASS[status] || 'navy'}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="kpi-label">{label}</div>
        {icon}
      </div>
      <div className="text-2xl font-extrabold tracking-tight text-[var(--aampl-text)] mt-1.5">{value}</div>
      {target && <div className="text-[11px] text-slate-500 mt-1">Target: {target}</div>}
    </div>
  );
}

export function Empty({ title, hint, action }) {
  return (
    <div className="text-center py-16 px-6 glass-card">
      <div className="mx-auto mb-4 w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #EEF3FF, #F3EEFF)' }}>
        <span className="w-3 h-3 rounded-full" style={{ background: 'linear-gradient(135deg, #4F6BFF, #8B5CF6)' }} />
      </div>
      <div className="text-lg font-bold text-[var(--aampl-text)] mb-2">{title}</div>
      {hint && <div className="text-sm text-slate-500 mb-4 max-w-md mx-auto">{hint}</div>}
      {action}
    </div>
  );
}

export function Loading() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="spinner h-10 w-10" />
    </div>
  );
}

export function Card({ title, action, children, className = '' }) {
  return (
    <GlassCard title={title} action={action} className={className}>
      {children}
    </GlassCard>
  );
}
